import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 01_49_52 PM.png';

// High-tech Cinema Icons
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import CastConnectedRoundedIcon from '@mui/icons-material/CastConnectedRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';

const LiveIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Live"
      subtitle="Engage Your Audience in Real-Time"
      desc="Go live, engage your audience, and stream your cinema content in real-time. Broadcast red-carpet premieres, auditions, and live Q&As with ultra-low latency and interactive monetization."
      image={image}
      themeColor="#e91e63"
      bgGradient="linear-gradient(135deg, rgba(233,30,99,0.2) 0%, rgba(233,30,99,0.02) 100%)"
      marqueeItems={[
        { icon: '🔴', tag: 'PREMIERE', text: 'Cannes Film Pitch stream live with 14,800 active viewers', time: '1m ago', color: '#e91e63' },
        { icon: '⚡', tag: 'ULTRA CDN', text: '4K ProRes 60FPS feed synchronized to 184 edge servers in 14ms', time: '3m ago', color: '#f59e0b' },
        { icon: '💬', tag: 'SMART CHAT', text: 'AI moderation filtered 1,420 spam bots in real-time', time: '5m ago', color: '#07a4f5' },
        { icon: '📺', tag: 'SIMULCAST', text: 'Simulcast active across YouTube 4K, Twitch, & Filmhook OTT', time: '8m ago', color: '#10b981' },
        { icon: '💰', tag: 'FAN TIPS', text: 'Indie director received $3,450 in live stream community funding', time: '12m ago', color: '#ec4899' },
        { icon: '☁️', tag: 'CLOUD DVR', text: 'Cloud DVR archived 2.5-hour live audition at 45Mbps master bitrate', time: '16m ago', color: '#8b5cf6' },
      ]}
      features={[
        {
          id: 'streaming',
          icon: <VideocamRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Ultra HD 4K Live Broadcast',
          desc: 'Broadcast in cinema-grade 4K 60FPS with zero buffering and sub-second glass-to-glass latency.',
          badge: '4K Ultra 60FPS',
          metric: '< 18ms Latency',
          highlight: 'Zero Buffering CDN',
          hasEqualizer: true,
        },
        {
          id: 'interaction',
          icon: <PeopleAltRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Viewer Interaction & Q&A',
          desc: 'Engage fans with live audience polling, real-time stage invites, and interactive talent casting calls.',
          badge: 'Interactive HUD',
          metric: 'Live Q&A + Polls',
          highlight: 'Virtual Green Room',
          hasPulse: true,
        },
        {
          id: 'chat',
          icon: <ForumRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Smart Chat & Moderation',
          desc: 'High-volume live chat with automated AI toxic speech filters, custom creator emojis, and super-chats.',
          badge: 'AI Moderated',
          metric: 'Zero-Spam Protocol',
          highlight: 'Verified Fan Badges',
        },
        {
          id: 'simulcast',
          icon: <CastConnectedRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Multi-Platform Simulcast',
          desc: 'Simulcast your live master feed to YouTube, Twitch, TikTok Live, and custom RTMP endpoints with one tap.',
          badge: 'Multi-RTMP',
          metric: '4+ Channels Synced',
          highlight: 'Full Bitrate Mirroring',
        },
        {
          id: 'monetization',
          icon: <MonetizationOnRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Direct Monetization & Tipping',
          desc: 'Earn instantly with pay-per-view live tickets, fan super-stickers, and transparent instant royalty splits.',
          badge: 'Instant Royalties',
          metric: 'Zero Middleman Fees',
          highlight: 'Smart Payouts',
        },
        {
          id: 'recording',
          icon: <CloudSyncRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Live Recording & Cloud DVR',
          desc: 'Automated 100% loss-free cloud recording with instantaneous VoD export, chapter tags, and clip highlights.',
          badge: 'Instant VoD',
          metric: 'Unlimited Cloud DVR',
          highlight: 'Auto Highlight Reel',
        },
      ]}
    />
  );
};

export default LiveIndustry;
